import React from 'react';
import { CometStar } from './BrandArtwork';
import { differentiators } from '../data/site';
export function Differentiators() {
  return <section id="difference" className="border-t border-ink/10 bg-cream py-20 md:py-28" data-id="element-25" data-mp="1mbnd07w5t6w9">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-26" data-mp="1r587vr2ghkr8">
        <div className="mx-auto max-w-2xl text-center" data-id="element-27" data-mp="1w3jhq1sr3v9g">
          <h2 className="font-display text-[32px] font-semibold leading-[1.12] tracking-[-0.02em] text-ink md:text-[44px]" data-id="element-28" data-mp="1w5477d07ko0g">
            The Black Comet approach
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-ink/70" data-id="element-29" data-mp="13eulag2n4e41">
            Independent thinking. Serious follow-through.
          </p>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-30" data-mp="1dcs76wx11yth">
          {differentiators.map((item, index) => <li key={item.title} data-id="element-31" data-mp="2juoxkgyoynjr" data-mpi={index}>
              <CometStar className={`h-3 w-3 ${index % 2 === 0 ? 'text-gold' : 'text-violet'}`} data-id="element-32" data-mp="2or5rxswhhy5a" />
              <h3 className="mt-5 font-display text-[22px] font-medium leading-tight text-ink" data-id="element-33" data-mp="bnj37vyq3lc4">
                {item.title}
              </h3>
              <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-ink/70" data-id="element-34" data-mp="7le6upgw4als">{item.detail}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}